/**
 * Private Park listings — individually-hosted, rentable fenced yards.
 *
 * Single source of truth: privateParks.json (same folder). It is read by
 * the website (this module), scripts/prerender.js, and the backend
 * (GET /api/private-parks, public fields only — never host contact).
 * See PrivateParkDetail.jsx for the full listing shape. The order of
 * `photos` is the carousel order (Jennifer's array is ordered by visual
 * content, not filename suffix — two uploads were swapped).
 */
import PRIVATE_PARKS_DATA from "./privateParks.json";

export const PRIVATE_PARKS = PRIVATE_PARKS_DATA;

export function getPrivateParkBySlug(slug) {
  return PRIVATE_PARKS.find((p) => p.slug === slug) || null;
}

export function getPrivateParksByCity(citySlug) {
  return PRIVATE_PARKS.filter((p) => p.citySlug === citySlug);
}
